import axiosInstance from './axiosInstance'

/**
 * Fetches elevation via backend proxy → OpenTopoData SRTM30m.
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @returns {Promise<number|null>} Elevation in meters or null on failure
 */
export const fetchElevation = async (lat, lng) => {
  try {
    const { data } = await axiosInstance.get('/elevation', {
      params: { lat, lng },
    })

    if (data?.status === 'OK' && data.results?.[0]?.elevation != null) {
      return Math.round(data.results[0].elevation)
    }
    return null
  } catch {
    return null
  }
}
